import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  RecaptchaModule,
  RecaptchaFormsModule,
  RECAPTCHA_SETTINGS,
  RecaptchaSettings,
} from 'ng-recaptcha';
import {
  EqualValidatorDirectiveModule,
  NotIncludesStringModule,
  NotRepeatedCharacterDirectiveModule,
  PasswordComplexityValidatorDirectiveModule,
  PipesModule,
  PodNgCoreModule,
  ValidationClassDirectiveModule,
  ValidationMessagesModule,
} from 'pod-ng-core';
import { TwoFaFormsModule } from 'src/components/2fa-forms/2fa-forms.module';
import { Confirm2faComponent } from './confirm-2fa/confirm-2fa.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import { RecoveryPasswordComponent } from './recovery-password/recovery-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { Set2faComponent } from './set-2fa/set-2fa.component';
import { environment } from '../../environments/environment';

@NgModule({
  declarations: [
    LoginComponent,
    LoginFormComponent,
    RecoveryPasswordComponent,
    ResetPasswordComponent,
    Set2faComponent,
    Confirm2faComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    TranslateModule.forChild(),
    ReactiveFormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    PodNgCoreModule.forChild(),
    LoginRoutingModule,
    ValidationMessagesModule,
    ValidationClassDirectiveModule,
    PipesModule,
    EqualValidatorDirectiveModule,
    TwoFaFormsModule,
    PasswordComplexityValidatorDirectiveModule,
    NotIncludesStringModule,
    NotRepeatedCharacterDirectiveModule,
  ],
  exports: [],
  providers: [
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: environment.recaptchaSiteKey } as RecaptchaSettings,
    },
  ],
})
export class LoginModule {}
